import { initialListPaginationMeta } from "utils/helpers/pagination";

import { AdminPriceState, AdminTableFormState } from "../types/index"

export const initialFormState: AdminTableFormState = {
  category: "",
  itemId: "",
  unit: "",
  basePrice: "",
  lastUpdatedAt: "2026-03-01",
  toDate: "2026-12-31",
  priceListType: "Default",
  vendorId: 1,
  vendorName: "Vendor name",
}

export const initialState: AdminPriceState = {
  loading: false,
  priceData: [],
  page: 1,
  perPage: 20,
  meta: initialListPaginationMeta,
  error: null,
  form: initialFormState,
  isAddModalOpen: false,
  selectedId: 0,
  itemNameDropDown: []
}